import { render, staticRenderFns } from "./HowWeHelp.vue?vue&type=template&id=95465516&scoped=true&"
import script from "./HowWeHelp.vue?vue&type=script&lang=js&"
export * from "./HowWeHelp.vue?vue&type=script&lang=js&"
import style0 from "./HowWeHelp.vue?vue&type=style&index=0&id=95465516&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95465516",
  null
  
)

export default component.exports